import type { UiMerchantStatus } from '../api/types';

export function mapDbToUi(db: string): UiMerchantStatus {
  if (db === 'active') return 'active';
  if (db === 'suspended') return 'suspended';
  if (db === 'blacklisted') return 'blacklisted';
  if (db === 'pending' || db === 'inactive') return 'pending';
  return 'pending';
}

export function mapUiToApi(status: UiMerchantStatus): string {
  if (status === 'active') return 'active';
  if (status === 'suspended') return 'suspended';
  if (status === 'blacklisted') return 'blacklisted';
  return 'pending';
}

export function badgeClass(status: UiMerchantStatus): string {
  if (status === 'active') return 'badge badge-success';
  if (status === 'pending') return 'badge badge-pending';
  if (status === 'suspended') return 'badge badge-pending';
  return 'badge badge-blocked';
}

export function btnClass(status: UiMerchantStatus, current: UiMerchantStatus): string {
  const base = 'st-btn';
  if (status !== current) return base;
  if (status === 'active') return `${base} active-btn`;
  if (status === 'pending') return `${base} pending-btn`;
  if (status === 'suspended') return `${base} pending-btn`;
  return `${base} blocked-btn`;
}

export function statusLabel(status: UiMerchantStatus): string {
  if (status === 'active') return 'Active';
  if (status === 'pending') return 'Pending';
  if (status === 'suspended') return 'Suspended';
  return 'Blacklisted';
}

export function isPendingKyb(status: string, kybStatus?: string | null): boolean {
  if (kybStatus === 'pending') return true;
  return mapDbToUi(status) === 'pending';
}
